import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, COMPANY_LIST, PUBLIC } from "../../common/URLs";

export const fetchCompanyList = async (page) => {
    const url = `${BASE_URL}/${PUBLIC}/${COMPANY_LIST}?page=${page}&perPageCount=16`; // Proxy path
    try {
      const token = await fetchToken()

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });
      // console.log("response", response)
      const data = await response.json();
      return data;
    } catch (error) {
      console.log("error", error);
    }
  };